<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="page_8"></a>Introduction</h2>
<p class="noindent">This is my first book and I hope you enjoy it. I’m passionate about crochet and hope to inspire others to feel the same. I learnt to crochet at a young age, taught by my mum and nan. I love the thought of a skill being passed down the generations. But no matter how you learn, I think it is important to have a hobby – something creative you enjoy that makes you happy.</p>
<p class="indent">My intention was to write a book containing crochet projects and novelty items to make you smile. This book contains 20 cute Christmas amigurumi projects which are simple, fun and easy to make and suitable for someone with a basic knowledge of crochet. Most of the patterns are worked using simple crochet stitches. Colourful and quirky, the finished items can be used as toys, standing or hanging decorations. They can be kept for yourself or given as gifts to family and friends, both children and adults. Please note that if you are giving one of these projects to a child under the age of 3, it is safer to embroider the eyes instead of using safety eyes.</p>
<p class="indent">Use your imagination and adapt the projects by changing yarn or colours, add pink earmuffs to the Penguin or crochet the Snowman a Christmas hat; decorate presents with the Holly Berries; string the Brussels Sprouts and Pigs in Blankets together and turn them into a novelty garland; or turn the heads of the Snowmen and Elves into Christmas baubles.</p>
<p class="indent">Whatever you decide to make, have fun!</p>
<p class="indent">Happy crocheting x</p>
<div class="img_container">
<p class="image"><a id="page_9"></a><img alt="" src="images/5-1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Introduction.vue?8b95fc4c